export interface ZoomConstraintSet extends MediaTrackConstraintSet {
  zoom?: number
  focusMode?: string
}
export interface ExtendedMediaTrackConstraints extends MediaTrackConstraints {
  zoom?: number
  focusMode: string
  advanced?: ZoomConstraintSet[]
}

export enum FacingMode {
  ENVIRONMENT = "environment",
  USER = "user",
}
